/**
 * 这个文件用于所有函数方法
 */
import { uuid } from './index';
import { Link, Node, Meta } from './model';
import { TreeNodeType, Direction, ToolsStatusEnum, } from './types';
import { Y_DRAG_GAP, DRAG_NODE_HEIGHT, NODE_DISTANCE_X, NODE_DISTANCE_Y, NODE_W, NODE_H, MERGE_NODE_DISTANCE,
// CONDITION_HEAD_NODE_HEIGHT,
// MINI_START_NODE_W,
// MINI_START_NODE_H,
 } from './const';
// 获取某个节点的父子节点 入参是当前节点的currentNode
export function getCurrentFatherAdnSonNode(data, currentNode) {
    if (Array.isArray(currentNode) && currentNode.length === 0)
        return;
    const fatherAdnSon = new Set();
    // 遍历二维数组，找到包含数字4的所有数组
    data.forEach(subArray => {
        // 获取父子节点
        if (subArray.includes(currentNode[0])) {
            // 移除数字4，剩下的就是兄弟节点
            const otherElement = subArray.find(element => element !== currentNode[0]);
            // 如果存在其他元素，添加到集合中
            if (otherElement) {
                fatherAdnSon.add(otherElement);
            }
        }
    });
    return fatherAdnSon;
}
// 获取某个节点的父节点 入参是当前节点currentNode
export function getCurrentFatherNode(data, currentNode) {
    if (Array.isArray(currentNode) && currentNode.length === 0)
        return;
    const fatherNode = new Set();
    // 遍历二维数组，找到包含数字4的所有数组
    data.forEach(subArray => {
        // 获取父子节点
        if (subArray[1] === currentNode[0]) {
            fatherNode.add(subArray);
        }
    });
    return fatherNode;
}
// 获取某个节点的子节点 入参是当前节点currentNode
export function getCurrentChildrenNode(data, currentNode) {
    if (Array.isArray(currentNode) && currentNode.length === 0)
        return;
    const childrenNode = new Set();
    // 遍历二维数组，找到包含数字4的所有数组
    data.forEach(subArray => {
        // 获取父子节点
        if (currentNode[1] === subArray[0]) {
            childrenNode.add(subArray);
        }
    });
    return childrenNode;
}
// 获取某个节点的所有兄弟节点 入参是当前节点[start,end]
export function getCurrentBrother(data, currentNode) {
    if (Array.isArray(currentNode) && currentNode.length === 0)
        return;
    const siblingsNode = new Set();
    data.forEach(pair => {
        if (pair.includes(currentNode[0]) && pair[0] === currentNode[0]) {
            // 过滤当前节点
            const isArrayEqual = pair.length === currentNode.length &&
                pair.every((value, index) => value === currentNode[index]);
            if (!isArrayEqual)
                siblingsNode.add(pair);
        }
    });
    return siblingsNode;
}
/** 根据id 获取节点
 * @param {*} nodeId Array | string
 * @param {*} nodeList
 * @return {*}
 */
export function findNodeById({ nodeId, nodeList }) {
    if (Array.isArray(nodeId)) {
        const nodeArr = nodeList.filter(node => nodeId.includes(node.id));
        return nodeArr || null;
    }
    else {
        const node = nodeList.find(node => node.id === nodeId);
        return node || null;
    }
}
/** 根据endId 获取linkList中第一次出现的 下标
 * @param {*} endId   string
 * @param {*} linkList
 * @return {*}
 */
export function getLinkFirstIndexByEndId({ endId, linkList }) {
    return linkList.findIndex(v => v.endId === endId);
}
/** 根据startId 获取linkList中第一次出现的 下标
 * @param {*} endId   string
 * @param {*} linkList
 * @return {*}
 */
export function getLinkFirstIndexByStartId({ startId, linkList }) {
    return linkList.findIndex(v => v.startId === startId);
}
/** 新增节点（change nodeList）
 * @param {*} addNode
 * @param {*} nodeList
 * @return {*}
 */
export function addNodeList({ nodeList, addNode }) {
    const addList = Array.isArray(addNode) ? addNode : [addNode];
    nodeList.push(...addList);
}
/** 删除节点 （change nodeList）
 * @param {*} delNodeIds Array | string
 * @param {*} nodeList
 * @return {*}
 */
export function delNodeList({ nodeList, delNodeIds }) {
    const delIds = Array.isArray(delNodeIds) ? delNodeIds : [delNodeIds];
    for (let i = nodeList.length - 1; i >= 0; i--) {
        if (delIds.includes(nodeList[i].id)) {
            nodeList.splice(i, 1);
        }
    }
}
/** 通过id  查找在linkList经过此元素之后的链路、关系、最后一个link的下标
 * @param {*} linkList
 * @param {*} nodeId
 * @return {*}
 */
export function findLinkChildById({ linkList, nodeId }) {
    // 记录受影响的nodeId，包含自己
    const affectedIds = [nodeId];
    // 记录受影响的link，不包含与父节点的link（不包含endId===nodeId的link）
    const childLinkList = [];
    // 受影响的最后一个link的下标,包含以当前id为endId的link
    let lastLinkIndex = getLinkFirstIndexByEndId({ endId: nodeId, linkList });
    // 当前节点的父节点
    const parentIds = [];
    // 当前节点的子孙节点，不包含自己
    let childIds = [];
    linkList.find((item, index) => {
        if (item.endId === nodeId) {
            parentIds.push(item.startId);
        }
        if (affectedIds.includes(item.startId)) {
            if (!affectedIds.includes(item.endId))
                affectedIds.push(item.endId);
            childLinkList.push(item);
            lastLinkIndex = index;
        }
    });
    childIds = affectedIds.slice(1);
    return {
        affectedIds,
        childLinkList,
        lastLinkIndex,
        parentIds,
        childIds,
    };
}
/** 新增兄弟节点(点击【添】)-仅一个
 * @param {*} linkList
 * @param {*} nodeList
 * @param {*} nodeId 点击的节点id
 * @param {*} width 需要添加节点的宽度
 * @param {*} height 需要添加节点的高度
 * @param {*} meta 需要添加节点的meta
 * @return {*}
 */
export function appendNode({ linkList, nodeId, nodeList, width, height, meta, }) {
    const { lastLinkIndex, parentIds } = findLinkChildById({ nodeId, linkList });
    const [parentId] = parentIds;
    const newNode = new Node({
        width,
        height,
        meta,
    });
    const newLink = new Link({
        startId: parentId,
        endId: newNode.id,
    });
    if (lastLinkIndex < 0)
        return;
    linkList.splice(lastLinkIndex + 1, 0, newLink);
    addNodeList({ nodeList, addNode: newNode });
    return { node: newNode, link: newLink };
}
/** 新增兄弟节点(点击【添】)-模型
 * @param {*} linkList
 * @param {*} nodeList
 * @param {*} nodeId 点击的节点id
 * @param {*} addModuleLink 被添加的模型节点关系（如：[1,3][3,4]）
 * @param {*} addModuleNode 被添加的模型节点
 * @return {*}
 */
export function addModuleBrotherNode({ linkList, nodeId, nodeList, addModuleLink, addModuleNode, }) {
    const bool = Array.isArray(addModuleLink) &&
        addModuleLink.length &&
        Array.isArray(addModuleNode) &&
        addModuleNode.length;
    if (!bool)
        return;
    const { lastLinkIndex, parentIds } = findLinkChildById({ nodeId, linkList });
    const [parentId] = parentIds;
    const newLink = new Link({
        startId: parentId,
        endId: addModuleLink[0].startId,
    });
    if (linkList.length && lastLinkIndex < 0)
        return;
    linkList.splice(lastLinkIndex + 1, 0, newLink, ...addModuleLink);
    addNodeList({ nodeList, addNode: addModuleNode });
}
/** 新增子节点(点击【+】)-仅一个
 * @param {*} linkList
 * @param {*} nodeList
 * @param {*} nodeId 点击的节点id
 * @param {*} width 需要添加节点的宽度
 * @param {*} height 需要添加节点的高度
 * @param {*} meta 需要添加节点的meta
 * @return {*}
 */
export function insertNode({ linkList, nodeId, nodeList, width, height, meta, }) {
    const newNode = new Node({
        width,
        height,
        meta,
    });
    const newLink = new Link({
        startId: nodeId,
        endId: newNode.id,
    });
    // 将所有以当前id为startId的startId改成新节点的id
    linkList.forEach(v => {
        if (v.startId === nodeId) {
            v.startId = newNode.id;
        }
    });
    // 再找到当前id为endId的第一个下标(目前只有合并的空节点会有多个【当前id为endId】，空节点的删除在解除合并处理，所以此处不会考虑下标有多个的场景)
    const index = getLinkFirstIndexByEndId({ endId: nodeId, linkList });
    linkList.splice(index + 1, 0, newLink);
    addNodeList({ nodeList, addNode: newNode });
    return { node: newNode, link: newLink };
}
/** 新增子节点(点击【+】)-模型
 * 不支持给有子节点的节点添加模型(因不知道将子节点拼接在模型节点的哪一个节点上)，如后续有相关需求再做调整
 * @param {*} linkList
 * @param {*} nodeList
 * @param {*} nodeId 点击的节点id
 * @param {*} addModuleLink 被添加的模型节点关系（如：[1,3][3,4]）
 * @param {*} addModuleNode 被添加的模型节点
 * @return {*}
 */
export function addModuleChildNode({ linkList, nodeId, nodeList, addModuleLink, addModuleNode, }) {
    const bool = Array.isArray(addModuleLink) &&
        addModuleLink.length &&
        Array.isArray(addModuleNode) &&
        addModuleNode.length;
    if (!bool)
        return;
    const newLink = new Link({
        startId: nodeId,
        endId: addModuleLink[0].startId,
    });
    // 找到当前id为endId的第一个下标
    const index = getLinkFirstIndexByEndId({ endId: nodeId, linkList });
    if (linkList.length && index < 0)
        return;
    linkList.splice(index + 1, 0, newLink, ...addModuleLink);
    addNodeList({ nodeList, addNode: addModuleNode });
}
/** 合并 节点
 * @param {*} mergeNodeList 合并项list
 * @param {*} nodeList
 * @param {*} linkList
 * @return {*}
 */
export function mergeNode({ mergeNodeList, nodeList, linkList }) {
    // 合并项目的nodeId集合
    const mergeNodeIds = mergeNodeList.map(item => item.id);
    // 合并线的activeId
    const activeId = new Date().getTime();
    // 插入的位置-index
    const spliceLinkList = [];
    // 记录每个选中后受影响的link数组
    const selectedChildLinkList = [];
    // 合并节点
    const newNode = new Node({
        width: 0,
        height: NODE_H,
        meta: new Meta({
            configKey: 'empty',
            extParam: {
                isMergeNode: true,
            },
        }),
    });
    nodeList.push(newNode);
    mergeNodeIds.forEach(id => {
        const { childLinkList } = findLinkChildById({ linkList, nodeId: id });
        if (childLinkList?.length > 0) {
            childLinkList.forEach(item => {
                if (item.startId === id) {
                    item.startId = newNode.id;
                    item.id = uuid(); // 重新赋值，否则无法重绘
                }
            });
            selectedChildLinkList.push(...childLinkList);
        }
    });
    selectedChildLinkList.forEach(item => {
        const index = linkList.findIndex(link => link.id === item.id);
        linkList.splice(index, 1);
    });
    linkList.forEach((item, i) => {
        // 处理需要插入的link集合
        if (mergeNodeIds.includes(item.endId)) {
            // 合并关系
            const newLink = new Link({
                startId: item.endId,
                endId: newNode.id,
                meta: {
                    activeId,
                },
            });
            spliceLinkList.push({
                index: i + spliceLinkList.length,
                link: newLink,
            });
        }
        // 修改合并时，可能合并项目后有子节点，则需要将此link的startId改为新的合并节点id
        if (mergeNodeIds.includes(item.startId)) {
            item.startId = newNode.id;
        }
    });
    spliceLinkList.forEach(v => {
        linkList.splice(v.index + 1, 0, v.link);
    });
    // 最后将合并影响的子孙节点都插入至合并节点后
    const firstIndex = getLinkFirstIndexByEndId({ endId: newNode.id, linkList });
    linkList.splice(firstIndex + 1, 0, ...selectedChildLinkList);
}
/** 取消合并
 * @param {*} activeId
 * @param {*} nodeList
 * @param {*} linkList
 * @return {*}
 */
export function cancelMerge({ activeId, nodeList, linkList }) {
    // 需要删除的link的id
    const delLinkIds = [];
    // 合并节点id
    let mergeNodeId = null;
    // 第一个合并节点id
    let firstMergeNodeId = null;
    // 先处理已合并节点为startId的link
    linkList.forEach(item => {
        // 拿到第一个合并项、合并节点id、需要删除的linkId集合
        if (item.meta?.activeId === activeId) {
            delLinkIds.push(item.id);
            if (!firstMergeNodeId)
                firstMergeNodeId = item.startId;
            if (!mergeNodeId)
                mergeNodeId = item.endId;
        }
        // 如果合并节点有子节点，则需要改子节点的startId
        if (item.startId === mergeNodeId) {
            item.startId = firstMergeNodeId;
        }
    });
    // 删除link
    for (let i = linkList.length - 1; i >= 0; i--) {
        if (delLinkIds.includes(linkList[i].id)) {
            linkList.splice(i, 1);
        }
    }
    // nodeList中 删除合并节点
    delNodeList({ nodeList, delNodeIds: mergeNodeId });
}
/** 修改合并
 * @param {*} oldMergeNodeList 初始合并项
 * @param {*} mergeNodeList 新的合并项
 * @param {*} nodeList
 * @param {*} linkList
 * @param {*} activeId
 * @return {*}
 */
export function editMerge({ activeId, mergeNodeList, nodeList, linkList }) {
    // 旧的合并节点id
    let odlMergeNodeId = null;
    // 合并节点的子孙link
    let oldMergeNodChildLinkList = [];
    // 新的合并项的nodeId集合
    const newMergeNodeIds = mergeNodeList.map(item => item.id);
    // 新的合并线的activeId
    const NewActiveId = new Date().getTime();
    // 插入的位置-index
    const spliceLinkList = [];
    // 记录每个选中后受影响的link数组
    const selectedChildLinkList = [];
    // 合并节点
    const newNode = new Node({
        width: 0,
        height: NODE_H,
        meta: new Meta({
            configKey: 'empty',
            extParam: {
                isMergeNode: true,
            },
        }),
    });
    newMergeNodeIds.forEach(id => {
        const { childLinkList } = findLinkChildById({ linkList, nodeId: id });
        if (childLinkList?.length > 0) {
            childLinkList.forEach(item => {
                if (item.startId === id) {
                    item.startId = newNode.id;
                    item.id = uuid(); // 重新赋值，否则无法重绘
                }
            });
            selectedChildLinkList.push(...childLinkList);
        }
    });
    // 需要删除的link的id 需要在上一步之后获取，因为上一步修改子孙开始link的id
    const delLinkIds = linkList.filter(item => item.meta?.activeId === activeId).map(val => val.id);
    // 先处理已合并节点为startId的link
    linkList.forEach((item, i) => {
        // 拿到旧的合并节点
        if (item.meta?.activeId === activeId) {
            if (!odlMergeNodeId) {
                odlMergeNodeId = item.endId;
                // 需要记录其=旧的合并节点的子孙link用于后续换位置
                const { childLinkList } = findLinkChildById({ linkList, nodeId: odlMergeNodeId });
                const list = [];
                childLinkList.forEach(v => {
                    if (v.startId === odlMergeNodeId) {
                        v.startId = newNode.id;
                    }
                });
                selectedChildLinkList.forEach(v => {
                    const index = childLinkList.findIndex(item => item.id === v.id);
                    if (index < 0 && v.endId !== odlMergeNodeId) {
                        list.push(v);
                    }
                });
                oldMergeNodChildLinkList = [...childLinkList, ...list];
                delLinkIds.push(...oldMergeNodChildLinkList.map(item => item.id));
            }
        }
        // 处理需要插入的link集合
        if (newMergeNodeIds.includes(item.endId)) {
            // 合并关系
            const newLink = new Link({
                startId: item.endId,
                endId: newNode.id,
                meta: {
                    activeId: NewActiveId,
                },
            });
            spliceLinkList.push({ index: i + spliceLinkList.length, link: newLink });
        }
        // 如果旧的合并节点有子节点，则需要改子节点的startId
        if (item.startId === odlMergeNodeId) {
            item.startId = newNode.id;
        }
    });
    // 先插入新的link
    spliceLinkList.forEach(v => {
        linkList.splice(v.index + 1, 0, v.link);
    });
    // 再删除link（包括旧的合并节点的子孙link）
    for (let i = linkList.length - 1; i >= 0; i--) {
        if (delLinkIds.includes(linkList[i].id)) {
            linkList.splice(i, 1);
        }
    }
    // 最后将旧的合并节点的子孙link插入到新的合并点
    // [...selectedChildLinkList, ...oldMergeNodChildLinkList]
    if (oldMergeNodChildLinkList.length) {
        const firstIndex = getLinkFirstIndexByEndId({ endId: newNode.id, linkList });
        linkList.splice(firstIndex + 1, 0, ...oldMergeNodChildLinkList);
    }
    // nodeList中 删除原来的合并节点
    delNodeList({ nodeList, delNodeIds: odlMergeNodeId });
    // 添加新的合并节点
    nodeList.push(newNode);
}
const addGetNodeX = ([startNode, endNode], params) => {
    const { offsetX, nodeMap = {}, nodeWidth } = params;
    const actualNodeWidth = typeof startNode.width === 'number' ? startNode.width : nodeWidth;
    const calcCoordinateX = () => {
        const startNodeX = startNode?.coordinate?.[0];
        const endOriginNode = nodeMap[endNode.id];
        const startOriginNode = nodeMap[startNode.id];
        const isMergeNode = endOriginNode?.meta?.extParam?.isMergeNode;
        const lastIsMerge = startOriginNode?.meta?.extParam?.isMergeNode;
        let value = startNodeX !== undefined ? startNodeX : startNode.getCoordinateX();
        if (isMergeNode) {
            value += actualNodeWidth + MERGE_NODE_DISTANCE;
        }
        else if (lastIsMerge) {
            value += offsetX - MERGE_NODE_DISTANCE;
        }
        else {
            value += actualNodeWidth + offsetX;
        }
        return value;
    };
    // X坐标依赖收集
    if (endNode.coordinateXFnList?.length) {
        endNode.coordinateXFnList.push(calcCoordinateX);
    }
    else {
        endNode.coordinateXFnList = [calcCoordinateX];
    }
    if (!endNode.getCoordinateX) {
        endNode.getCoordinateX = () => {
            const endOriginNode = nodeMap[endNode.id];
            let endNodeX = endNode?.coordinate?.[0];
            if (endNodeX !== undefined)
                return endNodeX;
            if (endNode.coordinateXFnList?.length > 1) {
                // 有多个值
                const all = endNode.coordinateXFnList.map(fn => fn());
                endNodeX = Math.max(...all);
            }
            else {
                // 一个值
                const [fnX] = endNode.coordinateXFnList;
                endNodeX = fnX();
            }
            let coordinate = endNode.coordinate || [];
            coordinate = [endNodeX, coordinate[1]];
            endOriginNode.coordinate = coordinate;
            endNode.coordinate = coordinate;
            return endNodeX;
        };
    }
};
const addGetNodeYFn = tier => {
    let currentTier = tier;
    return ([startNode, endNode], params) => {
        const { offsetY, nodeHeight, lastEndId, startId, nodeMap = {}, origin = [50, 50] } = params;
        if (!endNode.tier) {
            // 连接到新节点了
            if (lastEndId === startId) {
                endNode.tier = startNode.tier;
            }
            else {
                // 出现断层
                currentTier += 1;
                endNode.tier = currentTier;
            }
        }
        if (!endNode.getCoordinateY) {
            endNode.getCoordinateY = () => {
                const endOriginNode = nodeMap[endNode.id];
                let endNodeY = endNode?.coordinate?.[1];
                if (endNodeY !== undefined)
                    return endNodeY;
                if (endNode.tier === 1) {
                    endNodeY = origin[1];
                }
                else {
                    const tier = endNode.tier - 1;
                    endNodeY = origin[1] + tier * (offsetY + nodeHeight);
                }
                let coordinate = endNode.coordinate || [];
                coordinate = [coordinate[0], endNodeY];
                endOriginNode.coordinate = coordinate;
                endNode.coordinate = coordinate;
                return endNodeY;
            };
        }
    };
};
const cloneNodeHooks = nodeMap => {
    let cloneNodeMap = {};
    const addCloneNode = id => {
        const copyNode = cloneNodeMap[id];
        const realNode = nodeMap[id];
        if (!copyNode) {
            cloneNodeMap[id] = {
                id: realNode.id,
                configKey: realNode?.meta?.configKey,
                // miniStartNode: realNode?.miniStartNode,
                width: realNode.width,
                height: realNode.height,
            };
            return cloneNodeMap[id];
        }
        return copyNode;
    };
    const clearData = () => {
        cloneNodeMap = null;
    };
    return [cloneNodeMap, addCloneNode, clearData];
};
// 给链路集合relationList，补全从起始节点开始的一截链路
export const getCompletionPreRelationList = relationList => {
    // 开始节点
    const [firstNode] = relationList[0];
    // 补全了开始一截链路的集合
    const completionPreRelationList = [];
    relationList.forEach((item, index) => {
        // 链路上的起始节点
        const [firstNodeOfPath] = item;
        // const lastNodeOfPath = item[item.length - 1];
        if (firstNodeOfPath === firstNode) {
            completionPreRelationList.push(item);
        }
        else {
            const preList = relationList.slice(0, index + 1);
            const pathIndex = preList.findIndex(list => list.includes(firstNodeOfPath));
            const curPath = preList[pathIndex];
            const startIndex = curPath.indexOf(firstNodeOfPath);
            // const lastIndex = curPath.indexOf(lastNodeOfPath);
            completionPreRelationList.push([
                ...curPath.slice(0, startIndex),
                ...item,
                // ...curPath.slice(lastIndex + 1, curPath.length),
            ]);
        }
    });
    return completionPreRelationList;
};
const getInMergeIds = ({ relationList, mergeNodeIds }) => {
    const inMergeIds = [];
    const completionPreRelationList = getCompletionPreRelationList(relationList);
    if (relationList?.length && mergeNodeIds?.length) {
        // 过滤找到所有在合并链路上节点id们，会有重复
        mergeNodeIds.forEach(mergeId => {
            let tempInMergeIds = [];
            const newCompletionPreRelationList = completionPreRelationList.filter(item => item.includes(mergeId));
            const [firstPath, ...rest] = newCompletionPreRelationList;
            const lastPath = rest.pop();
            // 要开始截断的id
            let startId = null;
            // 合并节点在最后链路中的索引
            const mergeIdIndex = lastPath.indexOf(mergeId);
            lastPath.forEach((ele, index) => {
                if (firstPath.includes(ele) && index < mergeIdIndex) {
                    startId = ele;
                }
            });
            if (startId) {
                // 取交集
                newCompletionPreRelationList.forEach(item => {
                    tempInMergeIds.push(...item.slice(item.indexOf(startId) + 1, item.indexOf(mergeId)));
                });
            }
            // 去重
            tempInMergeIds = Array.from(new Set(tempInMergeIds));
            inMergeIds.push(...tempInMergeIds);
        });
    }
    return inMergeIds;
};
// 处理node节点上meta中的属性
const handlerMetaProp = ({ nodeList, linkList }) => {
    // linkList的endId集合
    const endIdList = linkList.map(item => item.endId);
    // 合并节点ids
    let mergeNodeIds = endIdList.filter((item, index) => endIdList.indexOf(item) !== index);
    mergeNodeIds = Array.from(new Set(mergeNodeIds));
    // 不展示'+'icon的节点id集合
    const canNotInsertNodeIds = [];
    // 链路集合
    const relationList = [];
    const [firstNode] = nodeList;
    // 开始轮询
    linkList.forEach((link, index) => {
        const { startId, endId } = link; // 开始节点和节数节点id
        const { endId: lastEndId } = linkList[index - 1] || { endId: firstNode.id }; // 上一个关系节点数据
        if (lastEndId === startId) {
            // 有序
            if (!relationList.length) {
                relationList[0] = [startId, endId];
            }
            else {
                relationList[relationList.length - 1].push(endId);
            }
        }
        else {
            // 断层
            relationList[relationList.length] = [startId, endId];
        }
        if (mergeNodeIds.includes(endId)) {
            canNotInsertNodeIds.push(startId);
        }
    });
    // 在合并链路上的节点id集合
    let inMergeIds = getInMergeIds({ relationList, mergeNodeIds });
    // 去重
    inMergeIds = Array.from(new Set(inMergeIds));
    nodeList.forEach(item => {
        const nodeId = item.id;
        const extParam = item.meta.extParam;
        // 是否为合并的特殊节点
        extParam.isMergeNode = mergeNodeIds.includes(nodeId);
        const { filterMyselfChildrenList } = handlerShrinkNum({
            nodeList,
            linkList,
            item,
        });
        // 是否在合并链路上
        extParam.inMerge = inMergeIds.includes(nodeId);
        // canInsert 合并节点的父节点不展示增加按钮
        // 结束节点(优先级最高)不展示增加节点(只能添加新字段，不能直接使用canInsert,因为旧数据保存的被合并节点的canInsert都为true)
        extParam.canInsert =
            item.meta.configKey === 'end_rout_node' ? false : !canNotInsertNodeIds.includes(nodeId);
        // 子孙节点中是否有工具为编辑态或错误
        const hasError = filterMyselfChildrenList?.some(node => {
            const meta = node?.meta;
            const toolsIsEdit = meta?.extParam?.toolsIsEdit;
            const toolsStatusIsError = [
                ToolsStatusEnum.SELECT_ERROR,
                ToolsStatusEnum.EDIT_ERROR,
                ToolsStatusEnum.VERIFY_ERROR,
            ].includes(meta?.extParam?.toolsStatus);
            return meta?.type === TreeNodeType.TOOLS && (toolsStatusIsError || toolsIsEdit);
        });
        // 收起节点是否禁用
        extParam.shrinkDisabled = extParam.inMerge || hasError;
    });
};
const handlerShrinkNum = ({ nodeList, linkList, item }) => {
    const nodeId = item.id;
    const extParam = item.meta.extParam;
    // 子孙节点ids
    const filterMyselfChildrenIds = findLinkChildById({
        nodeId,
        linkList,
    })?.childIds;
    // 子孙节点nodeList
    const filterMyselfChildrenList = findNodeById({
        nodeId: filterMyselfChildrenIds,
        nodeList,
    });
    if (!extParam.isOpen) {
        // 获取当前节点后面的节点数量 - 不包括合并节点和拖拽节点;
        const filterAfterChildren = filterMyselfChildrenList?.filter(ele => !ele.meta.extParam.isMergeNode && !ele.meta?.extParam?.isDragElement);
        // 收起节点的收起数量
        extParam.shrinkNum = filterAfterChildren.length;
    }
    return {
        filterMyselfChildrenList,
    };
};
export const renderStgyGraph = (params) => {
    const { linkList = [], nodeList = [], renderLinkList = [], nodeMap = {}, origin = [0, 0], offsetY = NODE_DISTANCE_Y, offsetX = NODE_DISTANCE_X, nodeWidth = NODE_W, nodeHeight = NODE_H, changeNodeAttributes,
    // miniStartNode = false,
     } = params || {};
    if (!nodeList?.length && !renderLinkList?.length)
        return;
    if (nodeList.length === 1) {
        const [beginNode] = nodeList;
        nodeMap[beginNode.id].coordinate = origin;
    }
    // 收起节点后页面只有一个渲染节点时，处理开始节点上meta中的属性，nodeList此时只有一个
    if (!renderLinkList.length) {
        nodeList.forEach(item => {
            handlerShrinkNum({ nodeList, linkList, item });
        });
        return;
    }
    // 创建克隆map
    const cloneHooksData = cloneNodeHooks(nodeMap);
    const [, addCloneNode, clearCloneNodeMap] = cloneHooksData;
    // 节点 映射到的 所有父节点Map
    const parentMap = {};
    const subMap = {};
    // 给第一个节点初始化数据
    const [firstNode] = nodeList;
    firstNode.coordinate = origin;
    const firstCloneNode = addCloneNode(renderLinkList[0].startId);
    firstCloneNode.getCoordinateY = () => origin[1];
    firstCloneNode.getCoordinateX = () => origin[0];
    firstCloneNode.coordinate = origin;
    firstCloneNode.tier = 1;
    // 创建计算Y的函数
    const addGetNodeY = addGetNodeYFn(firstCloneNode.tier);
    // 链路集合
    const relationList = [];
    // 开始轮询
    renderLinkList.forEach((link, index) => {
        const { startId, endId } = link; // 开始节点和节数节点id
        const { endId: lastEndId } = renderLinkList[index - 1] || { endId: firstNode.id }; // 上一个关系节点数据
        const startNode = addCloneNode(startId);
        const endNode = addCloneNode(endId);
        parentMap[endId] ? parentMap[endId].push(startId) : (parentMap[endId] = [startId]);
        subMap[startId] ? subMap[startId].push(endId) : (subMap[startId] = [endId]);
        if (lastEndId === startId) {
            // 有序
            if (!relationList.length) {
                relationList[0] = [startId, endId];
            }
            else {
                relationList[relationList.length - 1].push(endId);
            }
        }
        else {
            // 断层
            relationList[relationList.length] = [startId, endId];
        }
        addGetNodeX([startNode, endNode], {
            offsetX,
            nodeWidth,
            nodeMap,
            // miniStartNode,
        });
        addGetNodeY([startNode, endNode], {
            offsetY,
            nodeHeight,
            lastEndId,
            startId,
            nodeMap,
            origin,
        });
        // 业务处理node属性
        changeNodeAttributes?.({ link, index, startNode: nodeMap[startId], endNode: nodeMap[endId] });
    });
    // 数据处理
    handlerMetaProp({
        nodeList,
        linkList,
    });
    // 触发计算
    Object.values(cloneHooksData[0]).forEach(node => {
        node.getCoordinateX?.();
        node.getCoordinateY?.();
    });
    // 清空缓存数据
    clearCloneNodeMap();
    cloneHooksData[0] = null;
    return { parentMap, subMap, relationList };
};
/**
 * 展开收起 节点
 * @param nodeId 操作节点id
 * @param nodeList 节点集合
 * @returns
 */
export function shrinkOrExpandNode({ nodeId, nodeList }) {
    const node = findNodeById({ nodeId, nodeList });
    node.meta.extParam.isOpen = !node.meta.extParam.isOpen;
}
/**
 * 处理返回页面要渲染的nodeList和linkList
 * @param nodeList 节点集合
 * @param linkList 有序边集合
 * @returns
 */
export function initShrinkNode({ nodeList, linkList }) {
    // 收起节点的节点集合
    const shrinkNodeList = nodeList.filter(item => !item.meta.extParam.isOpen);
    // 收起节点ids
    const shrinkIds = shrinkNodeList.map(item => item.id);
    // 不展示的nodeId集合
    let hiddenIds = [];
    for (const nodeId of shrinkIds) {
        const subChildIds = [nodeId];
        const restShrinkIds = shrinkIds.filter(item => item !== nodeId);
        linkList.forEach(({ startId, endId, meta }) => {
            if (subChildIds.includes(startId)) {
                // 子孙节点中截到下一个是收起节点为止
                if (!subChildIds.includes(endId) &&
                    !restShrinkIds.includes(startId) &&
                    !meta?.isDragElement) {
                    subChildIds.push(endId);
                }
            }
        });
        hiddenIds.push(...subChildIds.slice(1));
    }
    // 去重
    hiddenIds = Array.from(new Set(hiddenIds));
    // 页面要渲染的节点集合
    const renderNodeList = nodeList.filter(item => !hiddenIds.includes(item.id));
    // 页面要渲染的边集合
    const renderLinkList = linkList.filter(item => {
        const { startId, endId } = item;
        return !hiddenIds.includes(startId) && !hiddenIds.includes(endId);
    });
    return {
        renderNodeList,
        renderLinkList,
    };
}
export const deleteMergeNodeRelation = (id, params) => {
    const { linkList = [], mergeId = '', broId = '', delMerge = false } = params || {};
    if (!linkList?.length)
        return;
    const { newList, effectRelation } = linkList.reduce((result, relation) => {
        const { startId, endId } = relation; // 开始节点和结束节点id
        let canInsert = true;
        // 删除 被删除节点的关系
        if (endId === id || startId === id) {
            canInsert = false;
        }
        if (delMerge && (startId === mergeId || endId === mergeId)) {
            canInsert = false;
        }
        if (result.effectIds?.length) {
            if (result.effectIds.includes(startId)) {
                result.effectIds.push(endId);
                result.effectRelation.push(relation);
                canInsert = false;
            }
        }
        if (startId === mergeId) {
            canInsert = false;
            result.effectIds.push(endId);
            result.effectRelation.push(relation);
        }
        if (canInsert) {
            result.newList.push(relation);
        }
        return result;
    }, {
        newList: [],
        effectIds: [],
        effectRelation: [], // 删除节点后面的全部关系数组
    });
    const insertIndex = newList.findIndex(r => r.endId === broId);
    if (delMerge) {
        effectRelation.forEach(r => {
            if (r.startId === mergeId) {
                r.startId = broId;
            }
        });
    }
    if (insertIndex !== -1) {
        newList.splice(insertIndex + (delMerge ? 1 : 2), 0, ...effectRelation);
    }
    return newList;
};
// 删除一个节点的关系 并上下拼接
export const deleteSingleNodeRelation = (id, params) => {
    const { linkList = [], hasJoin = true } = params || {};
    if (!linkList?.length)
        return;
    const res = linkList.reduce((result, relation, index) => {
        const backupRelation = { ...relation };
        const { startId, endId } = backupRelation; // 开始节点和结束节点id
        const { startId: nextStartId, endId: nextEndId, meta: nextMete } = linkList[index + 1] || {};
        let canInsert = true;
        if (!result.isStart) {
            if (endId === id) {
                // 遇到被删除的第一个关系
                result.isStart = true;
                if (!result.nodeParentId) {
                    // 记录 被删除的节点的 第一个父节点 方便后续凭借数据
                    result.nodeParentId = startId;
                }
                if (nextStartId === id && !result.nodeSubId) {
                    // 记录 被删除的节点 第一个子节点  方便后续拼接数据
                    result.nodeSubId = nextEndId;
                }
                // 如果下一个开始节点 是删除节点 需要前后拼接
                if (nextStartId === id && nextEndId && hasJoin) {
                    backupRelation.startId = startId;
                    backupRelation.endId = nextEndId;
                    backupRelation.meta = nextMete;
                }
                else {
                    canInsert = false;
                }
            }
        }
        else {
            // 如果开始节点等于删除节点 需要前后拼接
            if (startId === id) {
                if (result.nodeParentId && hasJoin) {
                    backupRelation.endId = endId;
                    backupRelation.startId = result.nodeParentId;
                    backupRelation.id = uuid();
                }
                else {
                    canInsert = false;
                }
            }
            else if (endId === id) {
                if (result.nodeSubId && hasJoin) {
                    backupRelation.startId = startId;
                    backupRelation.endId = result.nodeSubId;
                }
                else {
                    canInsert = false;
                }
            }
        }
        // 插入数据 并且防止重复插入
        if (canInsert) {
            const relationKey = `${backupRelation.startId}+${backupRelation.endId}`;
            if (!result.hasRelation[relationKey]) {
                result.newData.push(backupRelation);
                result.hasRelation[relationKey] = true;
            }
        }
        return result;
    }, {
        newData: [],
        hasRelation: {},
        isStart: false,
        nodeParentId: null,
        nodeSubId: null,
    });
    return res.newData;
};
// 根据结束id 获取第一个线路
function findLinkByEndId({ nodeId, linkList }) {
    const link = linkList.find(link => link.endId === nodeId);
    return link || null;
}
function findLinkByStartId({ nodeId, linkList }) {
    const link = linkList.find(link => link.startId === nodeId);
    return link || null;
}
// 获取当前之后的子孙节点（包括自己）
function findChildrenNodeList({ linkList, nodeId, nodeMap }) {
    const { affectedIds } = findLinkChildById({ linkList, nodeId });
    const childrenList = affectedIds.reduce((prev, currId) => {
        const node = nodeMap[currId];
        if (!node) {
            return [...prev];
        }
        if (!node?.meta?.extParam?.isDragElement) {
            return [...prev, node];
        }
        return [...prev];
    }, []);
    return childrenList;
}
/**
 * @Description: 获取nodeList中 最底部的y值
 * @param {*} nodeList
 * @return {*}
 */
function calcMaxY(nodeList) {
    let maxYBottom = 0;
    nodeList.forEach(node => {
        maxYBottom = Math.max(maxYBottom, node.height + node.coordinate[1]);
    });
    return maxYBottom;
}
/**
 * 节点是否可拖动
 * @param param0
 * @returns
 */
export function disabledNodeDrag({ sourceNode, linkList, draggable }) {
    if (!draggable)
        return true;
    // 获取源节点的连线
    const sourceLink = findLinkByEndId({ nodeId: sourceNode.id, linkList });
    // 兜底判断 如果是源节点连线不存在则说明是起始节点，那么不可以拖动
    if (!sourceLink)
        return true;
    const isInMerge = sourceNode.meta?.extParam?.inMerge;
    if (isInMerge)
        return true;
    if (sourceNode.meta.type === TreeNodeType.TOOLS) {
        if (sourceNode.meta.extParam.toolsIsEdit)
            return true; // 编辑态不允许拖
        // 除自己外是否有其他链路，如果有就可以拖动，没有的话说明没有同级节点
        const otherLinkList = linkList.filter(link => link.startId === sourceLink?.startId && link.endId !== sourceLink?.endId);
        return otherLinkList.length <= 0;
    }
}
/**
 * 根据元素坐标来查询目标节点 也就是要插入在哪个节点附近，找到节点后再根据节点的4个角的坐标来判断插入方向（上、下、右三个方向）
 * @param x 水平偏移量
 * @param offset 节点偏移量
 */
export function findNodeByCoordinate({ linkList, nodeList, offset = [] }) {
    const filteredDragNodeList = nodeList.filter(node => !node.meta?.extParam?.isDragElement);
    // 页面上展示的渲染节点
    const { renderNodeList } = initShrinkNode({
        linkList,
        nodeList: filteredDragNodeList,
    });
    const [x, y] = offset;
    // 找出离当前节点距离最近的点 用三角函数的方法 x^2+y^2 排序取最小值
    const absX = Math.abs(x);
    const absY = Math.abs(y);
    renderNodeList.sort((prev, curr) => {
        const prevCenterX = prev.width ? prev.coordinate[0] + prev.width / 2 : prev.coordinate[0]; // x中心点
        const prevCenterY = prev.height ? prev.coordinate[1] + prev.height / 2 : prev.coordinate[1]; // y中心点
        const currCenterX = curr.width ? curr.coordinate[0] + curr.width / 2 : curr.coordinate[0]; // x中心点
        const currCenterY = curr.height ? curr.coordinate[1] + curr.height / 2 : curr.coordinate[1]; // y中心点
        const prevDistance = Math.abs(Math.pow(prevCenterX - absX, 2)) + Math.abs(Math.pow(prevCenterY - absY, 2));
        const curDistance = Math.abs(Math.pow(currCenterX - absX, 2)) + Math.abs(Math.pow(currCenterY - absY, 2));
        return prevDistance - curDistance;
    });
    const targetNode = renderNodeList.slice(0, 1)?.[0];
    const isMergeNode = targetNode.meta?.extParam?.isMergeNode;
    const mergeOffset = 20;
    // 插入节点4个端点的坐标
    const targetNodePointCoordinate = [
        {
            // 上 [x1, y1] 下标就是枚举值 Direction
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] - mergeOffset, targetNode.coordinate[1] - mergeOffset]
                : [...targetNode.coordinate],
            direction: Direction.TOP,
        },
        {
            // 右 [x1 + w, y1]
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] + mergeOffset, targetNode.coordinate[1] - mergeOffset]
                : [targetNode.coordinate[0] + targetNode.width, targetNode.coordinate[1]],
            direction: Direction.RIGHT,
        },
        {
            // 下 [x1 + w, y1 + h]
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] + mergeOffset, targetNode.coordinate[1] + mergeOffset]
                : [
                    targetNode.coordinate[0] + targetNode.width,
                    targetNode.coordinate[1] + targetNode.height,
                ],
            direction: Direction.BOTTOM,
        },
        {
            // 左 [x1, y1 + h]
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] - mergeOffset, targetNode.coordinate[1] + mergeOffset]
                : [targetNode.coordinate[0], targetNode.coordinate[1] + targetNode.height],
            direction: Direction.LEFT,
        },
    ];
    targetNodePointCoordinate.sort((prev, curr) => {
        const prevDistance = Math.abs(Math.pow(prev.coordinate[0] - absX, 2)) +
            Math.abs(Math.pow(prev.coordinate[1] - absY, 2));
        const curDistance = Math.abs(Math.pow(curr.coordinate[0] - absX, 2)) +
            Math.abs(Math.pow(curr.coordinate[1] - absY, 2));
        return prevDistance - curDistance;
    });
    // 需要判断是否是最后节点 是最后节点的话 右边只有1个方向
    return {
        node: renderNodeList?.[0],
        direction: targetNodePointCoordinate?.[0]?.direction, // 插入的方向
    };
}
// 删除拖拽节点和连线
export function deleteDragNodeAndLink({ nodeList, linkList }) {
    const dragNodeIndex = nodeList.findIndex(node => node.meta?.extParam?.isDragElement);
    if (dragNodeIndex > -1) {
        nodeList.splice(dragNodeIndex, 1);
        const dragLinkIndex = linkList.findIndex(link => link.meta?.isDragElement);
        dragLinkIndex > -1 && linkList.splice(dragLinkIndex, 1);
    }
}
/**
 * 添加拖拽占位元素
 * @param param0
 * @returns
 */
export function appendDragNode({ sourceNode, targetNode, nodeList, linkList, direction, nodeMap }) {
    const isMergeTargetNode = targetNode?.meta?.extParam?.isMergeNode;
    const inMerge = targetNode?.meta?.extParam?.inMerge;
    // 不能拖到合并节点的上、左
    if (!sourceNode?.id)
        return { disabled: true };
    const linkByStartId = findLinkByStartId({ nodeId: targetNode.id, linkList });
    // 不能拖到合并节点的上、左
    if (isMergeTargetNode) {
        if ([Direction.TOP, Direction.LEFT].includes(direction))
            return { disabled: true };
    }
    else {
        // 不能拖动到合并内最后节点的右和下
        if (inMerge &&
            linkByStartId?.meta?.activeId !== -1 &&
            [Direction.RIGHT, Direction.BOTTOM].includes(direction))
            return { disabled: true };
    }
    const dragNodeIndex = nodeList.findIndex(node => node.meta?.extParam?.isDragElement);
    let dragNodeX = targetNode.coordinate[0];
    let dragNodeY = targetNode.coordinate[1] - Y_DRAG_GAP - DRAG_NODE_HEIGHT; // 默认左上
    let link = findLinkByEndId({ nodeId: targetNode.id, linkList }); // 默认作为结束节点来查询连线 默认TOP
    const renderChildrenList = findChildrenNodeList({ linkList, nodeId: targetNode.id, nodeMap });
    // 源子孙节点
    const sourceRenderChildrenList = findChildrenNodeList({
        linkList,
        nodeId: sourceNode.id,
        nodeMap,
    });
    let isChildrenNode = false;
    sourceRenderChildrenList.forEach(node => {
        node.meta.extParam.isDragging = true;
        if (node.id === targetNode.id) {
            isChildrenNode = true;
        }
    });
    // 不能拖到自己子孙节点上 也不让拖到开始和结束节点上
    const startNodeCondition = targetNode.meta?.configKey === 'start_node' &&
        [Direction.TOP, Direction.LEFT].includes(direction);
    // 结束节点条件判断
    const endNodeCondition = targetNode.meta?.configKey === 'end_rout_node' &&
        [Direction.RIGHT, Direction.BOTTOM].includes(direction);
    // 合并节点条件判断
    const mergeNodeCondition = isMergeTargetNode && [Direction.TOP, Direction.LEFT].includes(direction);
    if (isChildrenNode || startNodeCondition || mergeNodeCondition || endNodeCondition)
        return { disabled: true };
    const fiterdDragElementLinkList = linkList.filter(link => !link.meta.isDragElement);
    switch (direction) {
        // 拖动到了节点右边(RIGHT、BOTTOM) 就在下一个节点加入
        case Direction.RIGHT: // 右上
            link = findLinkByStartId({ nodeId: targetNode.id, linkList: fiterdDragElementLinkList });
            // 如果不存在则说明是最后节点 需要增加在最后
            if (!link) {
                dragNodeY = targetNode.coordinate[1] + DRAG_NODE_HEIGHT / 2;
            }
            else {
                dragNodeY = targetNode.coordinate[1] - Y_DRAG_GAP - DRAG_NODE_HEIGHT; // 按照xmind交互 收起也是直接显示在后面
            }
            if (isMergeTargetNode) {
                dragNodeX =
                    targetNode.coordinate[0] + NODE_DISTANCE_X + targetNode.width - MERGE_NODE_DISTANCE;
            }
            else {
                dragNodeX = targetNode.coordinate[0] + NODE_DISTANCE_X + targetNode.width;
            }
            break;
        case Direction.BOTTOM: // 右下
            link = findLinkByStartId({ nodeId: targetNode.id, linkList: fiterdDragElementLinkList });
            if (!link) {
                dragNodeY = targetNode.coordinate[1] + DRAG_NODE_HEIGHT / 2;
            }
            else {
                dragNodeY = calcMaxY(renderChildrenList) + Y_DRAG_GAP;
            }
            if (isMergeTargetNode) {
                dragNodeX =
                    targetNode.coordinate[0] + NODE_DISTANCE_X + targetNode.width - MERGE_NODE_DISTANCE;
            }
            else {
                dragNodeX = targetNode.coordinate[0] + NODE_DISTANCE_X + targetNode.width;
            }
            break;
        case Direction.LEFT:
            dragNodeX = targetNode.coordinate[0];
            dragNodeY = calcMaxY(renderChildrenList) + Y_DRAG_GAP;
            break;
    }
    const startNode = link ? nodeMap[link.startId] : targetNode;
    // 工具的话需要判断是否要处理后续逻辑
    if (sourceNode.meta.type === TreeNodeType.TOOLS) {
        const targetLink = findLinkByEndId({ nodeId: targetNode?.id, linkList });
        const sourceLink = findLinkByEndId({ nodeId: sourceNode?.id, linkList });
        if (!targetLink)
            return { disabeld: true };
        // TODO 调整判断
        if (sourceLink?.startId === startNode?.id && targetLink?.startId === startNode?.id) {
            //
        }
        else {
            return { disabled: true };
        }
    }
    if (dragNodeIndex > -1) {
        const dragNode = nodeList[dragNodeIndex];
        dragNode.coordinate = [dragNodeX, dragNodeY]; // 更新占位节点坐标
        const dragLinkIndex = linkList.findIndex(link => link.meta?.isDragElement);
        linkList[dragLinkIndex].startId = startNode.id; // 更新开始节点
        linkList[dragLinkIndex].endId = dragNode.id; // 拖拽占位节点不变
    }
    else {
        // 创建占位节点 拖动结束后移除
        const newNode = new Node({
            width: 40,
            height: DRAG_NODE_HEIGHT,
            coordinate: [dragNodeX, dragNodeY],
            meta: new Meta({
                extParam: {
                    isDragElement: true,
                    isOpen: false,
                },
            }),
        });
        nodeList.push(newNode);
        // 拖拽时的辅助线
        const newLink = new Link({
            startId: startNode.id,
            endId: newNode.id,
            meta: {
                isDragElement: true,
            },
        });
        linkList.unshift(newLink);
    }
    return {
        startNode,
    };
}
/**
 * 拖拽后更新路径
 * @param param0
 * @returns
 */
export function updateDragNode({ sourceNode, targetNode, linkList, nodeList, direction, disabled, nodeMap, }) {
    if (!targetNode || !sourceNode)
        return;
    const isOpen = targetNode?.meta?.extParam?.isOpen;
    if (!isOpen && [Direction.RIGHT, Direction.BOTTOM].includes(direction)) {
        shrinkOrExpandNode({ nodeId: targetNode.id, nodeList });
    }
    // 源节点的子孙关系
    const { childLinkList: sourceChildLinkList, lastLinkIndex: sourceLastLinkIndex, affectedIds: sourceNodeIds, } = findLinkChildById({
        linkList,
        nodeId: sourceNode.id,
    });
    // 重置拖动状态
    sourceNodeIds.forEach(nodeId => {
        const node = nodeMap[nodeId];
        node.meta.extParam.isDragging = false;
    });
    // 如果不能拖动上去则return
    if (disabled)
        return;
    // 源节点的关系下标
    const sourceLinkIndex = getLinkFirstIndexByEndId({ endId: sourceNode.id, linkList });
    // 记录源节点的上一个关系
    const sourceLinkByEnd = linkList[sourceLinkIndex];
    // 提取要移动的段
    const segment = linkList.slice(sourceLinkIndex, sourceLastLinkIndex + 1);
    // 移除原位置的段
    linkList.splice(sourceLinkIndex, sourceChildLinkList.length + 1);
    // 目标节点的子孙关系
    const { childLinkList: targetChildLinkList, lastLinkIndex: targetLastLinkIndex, parentIds: targetParentIds, } = findLinkChildById({
        linkList,
        nodeId: targetNode.id,
    });
    let newStartNodeId = targetParentIds[0];
    let insertIndex = -1;
    // 获取新位置下标
    switch (direction) {
        case Direction.TOP:
            // 找到需要插入的link下标
            insertIndex = getLinkFirstIndexByEndId({ endId: targetNode.id, linkList });
            break;
        case Direction.RIGHT:
            if (targetChildLinkList.length > 0) {
                insertIndex = getLinkFirstIndexByStartId({ startId: targetNode.id, linkList });
            }
            else {
                insertIndex = getLinkFirstIndexByEndId({ endId: targetNode.id, linkList }) + 1;
            }
            newStartNodeId = targetNode.id;
            break;
        case Direction.BOTTOM:
            if (targetChildLinkList.length > 0) {
                insertIndex = targetLastLinkIndex + 1; // 插入子孙最后一个的后面
            }
            else {
                insertIndex = getLinkFirstIndexByEndId({ endId: targetNode.id, linkList }) + 1;
            }
            newStartNodeId = targetNode.id;
            break;
        case Direction.LEFT:
            insertIndex = targetLastLinkIndex + 1; // 插入子孙最后一个的后面
            break;
    }
    // 将段插入到新位置
    linkList.splice(insertIndex, 0, ...segment);
    sourceLinkByEnd.startId = newStartNodeId; // 修改关系
    sourceLinkByEnd.id = uuid(); // 重新修改linkId 这一步是为了更新拖拽后连线绘制，否则在拖拽后无法触发重新绘制，导致拖动到合并节点上原点不消失
}
/**
 * 设置高亮路径
 * @param param0
 */
export function lightenPath({ nodeIds, nodeList, linkList, }) {
    if (nodeIds.length === 0) {
        nodeList.forEach(node => {
            node.meta && (node.meta.extParam.isHighLight = false);
        });
        linkList.forEach(link => {
            link.meta && (link.meta.isHighLight = true);
        });
        return;
    }
    // 设置高亮节点
    const lightenNodeList = nodeIds.map(nodeId => {
        return {
            ...findNodeById({ nodeId, nodeList }),
        };
    });
    lightenNodeList.forEach(node => {
        node.meta && (node.meta.extParam.isHighLight = true);
    });
    // 设置高亮连线
    const endLinkList = linkList.filter(link => !!findNodeById({ nodeId: link.endId, nodeList: lightenNodeList }));
    const lightenLinkList = endLinkList.filter(link => !!findNodeById({ nodeId: link.startId, nodeList: lightenNodeList }));
    lightenLinkList.forEach(link => {
        link.meta.isHighLight = true;
    });
}
